import { React, useState, useEffect } from "react";
import { PortalComponent, ModalComponent, CardComponent, SwitchComponent, TableComponent, ButtonIconComponent, SelectComponent, ButtonActionComponent } from '../../../components/pages/index'
import { useGetApiWs } from "../../../hooks";
import { api, apiConfig } from "../../../util/api";
import Swal from 'sweetalert2';

const AssignCities = props => {
    const urlCustomer = useGetApiWs('admin', 'entity', 'customer-get');
    const urlCustomerStatus = useGetApiWs('admin', 'entity', 'customer-change-status');
    const urlCities = useGetApiWs('admin', 'entity', 'city-get');
    const urlCustomerSave = useGetApiWs('admin', 'entity', 'customer-save');
    const urlCustomerDelete = useGetApiWs('admin', 'entity', 'customer-delete');

    const [studies, setStudies] = useState([]);
    const [lbStudy, setLbStudy] = useState(null);
    const [categories, setCategories] = useState([]);
    const [lbCategories, setLbCategories] = useState(null);
    const [cities, setCities] = useState([]);
    const [lbCities, setLbCities] = useState(null);

    const [StudyIsLoading, setStudyIsLoading] = useState(true);
    const [CategoryIsLoading, setCategoryIsLoading] = useState(true);
    const [CitiesIsLoading, setCitiesIsLoading] = useState(true);

    const [TbData, setTbData] = useState([]);

    const fetchCustomersStudies = async () => {
        const req = await api().post(urlCustomer, { type_info: 'studies', customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.study_type_id;
            rObj['label'] = obj.study_type_name;
            return rObj;
        });
        setStudies(options);
        setStudyIsLoading(false);
    }

    const fecthCustomerCategories = async (studiesId) => {
        const req = await api().post(urlCustomer, { type_info: `categories`, study_id: studiesId, customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.category_id;
            rObj['label'] = obj.category_name;
            return rObj;
        });
        setCategories(options);
        setCategoryIsLoading(false);
    }

    const fecthCustomerCategoriesCities = async (studiesId, categoryId) => {
        const req = await api().post(urlCustomer, { type_info: `citiesadmin`, study_id: studiesId, customer_id: props.companyId, category_id: categoryId }, apiConfig());
        if (req.data.status === 'success') {
            setTbData(req.data.response);
        } else {
        }
        setCategoryIsLoading(false);
    }

    const fetchCitiesLeft = async (studiesId, categoryId) => {
        const req = await api().post(urlCities, { study_id: studiesId, customer_id: props.companyId, category_id: categoryId }, apiConfig());
        const res = req.data;
        if (res.status === 'success') {
            var options = res.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.city_id
                rObj['label'] = obj.name
                return rObj;
            });
            setCities(options)
        } else {
        }
        setCategoryIsLoading(false);
    }

    const fetchChangeStatus = async (customer_category_city_id) => {
        const req = await api().post(urlCustomerStatus, { type_info: 'cities', customer_category_city_id: customer_category_city_id }, apiConfig());
        const res = req.data;
        if (res.status === 'success') {
            fecthCustomerCategoriesCities(lbStudy.value, lbCategories.value);
            fetchCitiesLeft(lbStudy.value, lbCategories.value);
        } else {
        }
    }

    const fetchSave = async () => {
        const req = await api().post(urlCustomerSave, { type_info: 'cities', customer_id: props.companyId, study_id: lbStudy.value, category_id: lbCategories.value, city_id: lbCities.value }, apiConfig());
        console.log(req.data);
        if (req.data.status == 'success') {
            fecthCustomerCategoriesCities(lbStudy.value, lbCategories.value);
            fetchCitiesLeft(lbStudy.value, lbCategories.value);
            setLbCities([])
        } else {
        }
    }

    const fetchDelete = async (customer_category_city_id) => {
        const req = await api().post(urlCustomerDelete, { type_info: `cities`, customer_category_city_id: customer_category_city_id }, apiConfig());
        fecthCustomerCategoriesCities(lbStudy.value, lbCategories.value);
        fetchCitiesLeft(lbStudy.value, lbCategories.value);
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Se eliminó correctamente',
            showConfirmButton: false,
            timer: 1000
        })

    }
    const StudyChange = async vals => {
        setLbStudy(vals)
        if (vals === null) {
            setLbCategories(null)
            setCategories([])
        } else {
            setLbCategories(null)
            setCategories([])
            fecthCustomerCategories(vals.value)
        }
    }

    const CategoryChange = async vals => {
        setLbCategories(vals)
        if (vals != null) {
            fetchCitiesLeft(lbStudy.value, vals.value)
            fecthCustomerCategoriesCities(lbStudy.value, vals.value)
        }
    }

    const CitiesChange = async vals => {
        setLbCities(vals)
    }

    const tbColumns = [
        /* { name: 'ID', selector: row => row.customer_category_city_id, hide: 'lg' }, */
        { name: 'CIUDADES', selector: row => row.name, wrap: true },
        { name: 'PRODUCCIÓN?', button: true, cell: row => <SwitchProduction enabled={row.is_ready_for_report} customer_category_city_id={row.customer_category_city_id}></SwitchProduction> },
        { name: 'ELIMINAR', button: true, cell: row => <BtnDelete customer_category_city_id={row.customer_category_city_id} ></BtnDelete> }
    ]

    const SwitchProduction = (props) => {
        return (
            <SwitchComponent enabled={(props.enabled == 1) ? true : false} function={() => { fetchChangeStatus(props.customer_category_city_id) }} />
        )
    }

    const BtnDelete = (props) => {
        return (
            <div>
                <ButtonIconComponent icon="trash" onClick={() => { fetchDelete(props.customer_category_city_id) }} className="bg-red-500 p-2 m-1 rounded-md text-white"></ButtonIconComponent>
            </div>
        )
    }

    useEffect(() => {
        fetchCustomersStudies();
    }, [])

    return (
        <PortalComponent>
            <ModalComponent header={"ASIGNAR CIUDADES"} onCloseModal={props.closeModal}>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div className="grid grid-cols-1 gap-4 content-start">
                        <SelectComponent label="ESTUDIOS" options={studies} value={lbStudy} onChange={StudyChange} isLoading={StudyIsLoading} />
                        <SelectComponent label="CATEGORIAS" options={categories} value={lbCategories} onChange={CategoryChange} isLoading={CategoryIsLoading} />
                        <SelectComponent label="CIUDADES RESTANTES" options={cities} value={lbCities} onChange={CitiesChange} isLoading={CitiesIsLoading} />
                        <ButtonActionComponent name="AGREGAR" onClick={fetchSave} />
                    </div>
                    <div>
                        <CardComponent header={<h3 className="font-medium" >CIUDADES</h3>} footer={null}>
                            <TableComponent keyField="customer_category_id" columns={tbColumns} data={TbData} highlightOnHover={true} />
                        </CardComponent>
                    </div>
                </div>
            </ModalComponent>
        </PortalComponent>
    )
}
export default AssignCities;